<template>
  <el-row>
    <el-col :span="24" v-for="(attrOp,idx) in attrForm" :key="idx" class="attr-box">
      <el-form :model="attrFormData[idx]" :rules="attrFormRule[idx]" class="demo-formData" :ref="'attrFrom'+idx">
        <el-row>
          <el-col v-for="(columnOP,index) in attrOp" :key="index" :span="12">
            <el-form-item
              :label="columnOP.label"
              :prop="columnOP.prop"
              :class="{'is-required':columnOP.specialRule}"
              :label-width="column.labelWidth"
            >
              <!--输入框-->
              <el-input
                v-if="columnOP.type === columnType.input"
                v-model="attrFormData[idx][columnOP.prop]"
                :disabled="columnOP.disabled"
                @change="valueChange(columnOP,idx)"
              ></el-input>

              <!--输入框-->
              <el-input
                v-if="columnOP.type === columnType.password"
                type="password"
                v-model="attrFormData[idx][columnOP.prop]"
              ></el-input>
              <el-input
                v-if="columnOP.type === columnType.repassword"
                type="password"
                v-model="attrFormData[idx][columnOP.prop]"
              ></el-input>

              <!--数字输入框-->
              <el-input-number
                v-if="columnOP.type === columnType.inputNumber"
                v-model="attrFormData[idx][columnOP.prop]"
                :precision="columnOP.precision"
                :min=" columnOP.min"
                :max=" columnOP.max"
              ></el-input-number>

              <!--文本域-->
              <el-input
                type="textarea"
                v-if="columnOP.type === columnType.textarea"
                v-model="attrFormData[idx][columnOP.prop]"
              ></el-input>

              <!--下拉框-->
                <el-select :class='{"multiple-select":columnOP.multiple}' :clearable="columnOP.clearable || false"
                          v-if="columnOP.type === columnType.select" v-model="attrFormData[idx][columnOP.prop]"
                          placeholder="请选择" @change="selectChange(columnOP,idx)"
                          :multiple="columnOP.multiple || false"
                          :collapse-tags="columnOP.collapseTags || false"
                          :disabled="columnOP.disabled"
                >
                  <el-option v-for="item in columnOP.data" :key="item.value||item.id" :label="item.label||item.name" :title="item.label||item.name"
                            :value="item.value||item.id"></el-option>
                </el-select>

              <!--单选按钮-->
              <el-radio-group
                v-if="columnOP.type === columnType.radio"
                v-model="attrFormData[idx][columnOP.prop]"
              >
                <el-radio
                  v-for="item in columnOP.data"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-radio>
              </el-radio-group>

              <!--多选按钮-->
              <el-checkbox-group
                v-if="columnOP.type === columnType.checkbox"
                v-model="attrFormData[idx][columnOP.prop]"
              >
                <el-checkbox v-for="item in columnOP.data" :key="item.value" :label="item.label"></el-checkbox>
              </el-checkbox-group>

              <!--级联选择器-->
              <el-cascader
                v-if="columnOP.type === columnType.cascader"
                v-model="attrFormData[idx][columnOP.prop]"
                :options="columnOP.data"
                @change="columnOP.change"
                :props="columnOP.props"
                :show-all-levels="columnOP.showAllLevels"
              ></el-cascader>

              <!--开关-->
              <el-switch v-if="columnOP.type === columnType.switch" v-model="attrFormData[idx][columnOP.prop]"></el-switch>

              <!--滑块-->
              <el-slider
                v-if="columnOP.type === columnType.slider"
                v-model="attrFormData[idx][columnOP.prop]"
                :step="10"
                show-stops
              ></el-slider>

              <!--时间选择器 可配置间隔-->
              <el-time-select
                v-if="columnOP.type === columnType.timeSelect"
                v-model="attrFormData[idx][columnOP.prop]"
                :picker-options="{start: '08:30',step: '00:15',end: '18:30'}"
                placeholder="选择时间"
              ></el-time-select>

              <!--日期选择器-->
              <el-date-picker
                v-if="columnOP.type === columnType.datePicker"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="attrFormData[idx][columnOP.prop]"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>

              <!--日期时间选择器-->
              <el-date-picker
                v-if="columnOP.type === columnType.dateTimePicker"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="attrFormData[idx][columnOP.prop]"
                placeholder="选择日期时间"
              ></el-date-picker>

              <!--文件上传-->
              <file-upload
                :ref="columnOP.prop"
                :fileOptions="columnOP"
                v-if="columnOP.type === columnType.uploadFile"
              ></file-upload>
              <!--穿梭框-->
              <el-transfer
                v-if="columnOP.type === columnType.transfer"
                :filterable="columnOP.filterable"
                :filter-method="columnOP.filterMethod"
                :titles="columnOP.titles"
                :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
                }"
                v-model="attrFormData[idx][columnOP.prop]"
                :data="columnOP.data"
              ></el-transfer>
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="idx > 0" class="icon-opration">
             <i class="el-icon-remove-outline add-icon" @click="removeColumn(idx)"></i>
          </el-col>
          <el-col :span="2" v-if="idx == 0" class="icon-opration">
           <i class="el-icon-circle-plus-outline add-icon" @click="addColumn"></i>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    column: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      attrFormData: [],
      attrFormRule: [],
      attrForm: [],
      formModel: {},
      formRule: {},
      columnType:this.$utils.columnType,
    };
  },
  created() {
     this.initData();
  },
  methods: {
    //所有子组件必有此方法为当前数据赋值
    setValue(){
        let formModel = this.$store.state[this.$utils.storeKeys.CURRENTFORM];
        let attrList = formModel[this.column.prop];
        if(attrList && attrList.length > 0){
        this.attrFormData = [];
        this.attrFormRule = [];
        this.attrForm = [];
        let keys = Object.keys(this.formModel); 
        attrList.map((attr, index)=>{
          let formData = {};
          let formItem = this.$utils.deepClone(this.column.column);
          keys.map(key=>{
            formData[key] = attr[key];
            let currentColumn = formItem.filter(item => {
              return item.prop === key
            });
            if (currentColumn.length > 0) {
              let item = currentColumn[0];
              // 获取下拉值
              if (item.url && item.type === this.columnType.select) {
                this.getSelectData(item,index);
              }
            }   
          });
          this.attrFormData.push(Object.assign({}, formData));
          this.attrFormRule.push(Object.assign({}, this.formRule));
          this.attrForm.push([...formItem]);
        });
      };
    },
    clearData(){
      this.initData();
    },
    initData(){
      this.formModel = {};
      this.formRule = {};
      this.attrFormData=[];
      this.attrFormRule=[];
      this.attrForm = [];
      this.column.column.map(item => {
        if(item.type === this.columnType.select && item.multiple == true){
          this.$set(this.formModel, item.prop, []);  
        }else{
          this.$set(this.formModel, item.prop, '');
        }
        this.$set(this.formRule, item.prop, item.rule || []);
        // 获取下拉值
        if (item.url && item.type === this.columnType.select && (!item.data || item.data.length == 0)) {
          this.getSelectData(item,0);
        }
      });
      this.$nextTick(()=>{
        this.attrFormData.push(Object.assign({},this.formModel));
        this.attrFormRule.push(Object.assign({},this.formRule));
        this.attrForm.push(...[this.column.column]);
        this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
            key: this.column.prop,
            value: []
        });
      });
     
    },
    // 获取各种下拉菜单信息
    getSelectData(column,index, param,url) {
      let params = Object.assign(column.param || {},param || {});
        // 缓存读取
        column.data = this.$utils.getDataByKey(column.url);
        if (!column.data || column.data.length == 0) {
          this.$axios.fetchPost((column.url||url) + '/list', params || {}).then(data => {
            column.url = url || column.url;
            let selectData = data.data;
            if (data.code == 200) {
              this.$set(column, 'data', selectData);
              if (column.defaultIndex != undefined) {
                this.attrFormData[index][column.prop] = column.data[column.defaultIndex].value;
              }
              if (column.cache) {
                this.$utils.setDataByKey(column.url, column.data);
              }
              if(this.attrFormData[index][column.prop]){ 
                this.selectChange(column,index, true);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        }
    },
    // 下拉框联动
    selectChange(column, index,fillBack) {
      if (column.childProps) {// 根据当前选项获取子集
        // 联动字段选项赋值
        let childColumn = this.column.column.filter(item => {
          return item.prop === column.childProps
        });

        if (!childColumn || !childColumn.length > 0) {
          return;
        }
        childColumn = childColumn[0];
        // 当前父类选择的数据
        let parentData = column.data.filter(dataItem => {
          return dataItem.value|| dataItem.id == this.attrFormData[index][column.prop]
        });
        // 错误数据兼容
        if (parentData.length > 0) {
          childColumn.data = parentData[0].children;
        }
        this.attrFormData[index][childColumn.prop] = '';
      } else if (column.selectAssociated) {// 根据当前选项查询数据
        // 关联字段选项赋值
        let associatedcolumn = this.attrForm[index].filter(item => {
          return item.prop === column.selectAssociated.prop
        });
        if (!associatedcolumn || !associatedcolumn.length > 0) {
          return;
        }
        if (!fillBack) {
          this.attrFormData[index][associatedcolumn[0].prop] = '';
        }
        let param = {};
        param[column.associatedKey||column.prop] = this.attrFormData[index][column.prop];
        this.getSelectData(associatedcolumn[0],index, param,column.selectAssociated.url);
      }
      this.setNameFormId(column,index);
      if (!fillBack) {
        column.change && column.change(this.attrFormData[index],column);
      }
    },
    valueChange(column,index){
      column.change && column.change(this.attrFormData[index],column);
    },
    //获取下拉时选择的名称
    setNameFormId(columnOP,index){
      if(columnOP.multiple || !(/[\w]Id$/).test(columnOP.prop) || !columnOP.data || columnOP.data.length ==0)return;
      if(this.attrFormData[index][columnOP.prop]){
        this.attrFormData[index][columnOP.prop.replace(/(.*)Id/,'$1Name')]='';
      }
      let currentItem = columnOP.data.filter(item => {return item.id == this.attrFormData[index][columnOP.prop]});
      if(currentItem.length>0)
        this.attrFormData[index][columnOP.prop.replace(/(.*)Id/,'$1Name')]=currentItem[0].name;
    },
    addColumn() {
      this.attrFormData.push(this.$utils.deepClone(this.formModel));
      this.attrFormRule.push(this.$utils.deepClone(this.formRule));
      this.attrForm.push(this.$utils.deepClone(this.column.column));
    },
    removeColumn(index){
       this.attrFormData.splice(index, 1);
      this.attrFormRule.splice(index, 1);
      this.attrForm.splice(index, 1);
    },
    getFormData(){
      let isValidate = true;
      this.attrForm.map((item,index)=>{
         this.$refs['attrFrom'+index][0].validate((valid) => {
             if (!valid) {
               isValidate = false;
             }
         });
      });
      if(isValidate){
        this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
            key: this.column.prop,
            value: this.attrFormData
        });
      }else{
        return false;
      }
    }
  }
};
</script>
<style>
.attr-box{
  position: relative;
  margin-top: 10px;
}
.attr-box:first-child{
  margin-top:0;
}
 .attr-box .icon-opration{
    position: absolute;
    right: -20px;
    top: 3px;
 }
.add-icon {
  color: #409eff;
  font-size: 20px;
  margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/controls/attributeEditor.vue